import { gql } from '@apollo/client';

export const UPDATE_INTEGRATION_OVERRIDE_BY_PK = gql`
    mutation UpdateIntegrationOverrideByPk($override_id: uuid!, $update: integration_overrides_set_input = {}) {
        update_integration_overrides_by_pk(pk_columns: { override_id: $override_id }, _set: $update) {
            override_id
            status
        }
    }
`;
